package team.platforma.multiplatform_material_extension.ui.dialog

import androidx.compose.animation.animateContentSize
import androidx.compose.foundation.border
import androidx.compose.foundation.clickable
import androidx.compose.foundation.interaction.MutableInteractionSource
import androidx.compose.foundation.layout.Box
import androidx.compose.foundation.layout.Column
import androidx.compose.foundation.layout.WindowInsets
import androidx.compose.foundation.layout.asPaddingValues
import androidx.compose.foundation.layout.calculateEndPadding
import androidx.compose.foundation.layout.calculateStartPadding
import androidx.compose.foundation.layout.fillMaxSize
import androidx.compose.foundation.layout.fillMaxWidth
import androidx.compose.foundation.layout.navigationBarsPadding
import androidx.compose.foundation.layout.padding
import androidx.compose.foundation.layout.safeDrawing
import androidx.compose.foundation.layout.systemBars
import androidx.compose.foundation.layout.widthIn
import androidx.compose.foundation.layout.windowInsetsPadding
import androidx.compose.material3.Card
import androidx.compose.material3.CardColors
import androidx.compose.runtime.Composable
import androidx.compose.runtime.DisposableEffect
import androidx.compose.runtime.getValue
import androidx.compose.runtime.mutableStateOf
import androidx.compose.runtime.remember
import androidx.compose.runtime.setValue
import androidx.compose.ui.Alignment
import androidx.compose.ui.Modifier
import androidx.compose.ui.graphics.Color
import androidx.compose.ui.unit.LayoutDirection
import androidx.compose.ui.unit.dp
import androidx.compose.ui.window.Dialog
import androidx.compose.ui.window.DialogProperties
import team.platforma.multiplatform_material_extension.setTransparentSystemBars
import team.platforma.multiplatform_material_extension.ui.dialog.style.CommonDialogStyle
import team.platforma.multiplatform_material_extension.ui.dialog.style.DialogStyle
import team.platforma.multiplatform_material_extension.ui.dialog.utils.CommonDialogViewState
import team.platforma.multiplatform_material_extension.ui.dialog.utils.keyBoardPadding
import team.platforma.multiplatform_material_extension.ui.dialog.utils.observeKeyBoard

@Composable
fun CommonDialog(
    onDismiss: () -> Unit,
    title: @Composable () -> Unit = {},
    properties: DialogProperties = DialogProperties(usePlatformDefaultWidth = false),
    customStyle: DialogStyle? = null,
    dialogAlignment: Alignment = Alignment.Center,
    changeVisibleState: Boolean = true,
    content: @Composable () -> Unit
) {
    val dialogState = CommonDialogViewState

    var keyBoardPadding by remember { mutableStateOf(0) }

    observeKeyBoard {
        keyBoardPadding = it
    }

    if (changeVisibleState) {
        DisposableEffect(Unit) {
            dialogState.setState(true)
            onDispose {
                dialogState.setState(false)
            }
        }
    }


    Dialog(
        onDismissRequest = {
            onDismiss()
        },
        properties = properties
    ) {
        setTransparentSystemBars()
        Box(
            modifier = Modifier.fillMaxSize()
                .clickable(
                    interactionSource = remember { MutableInteractionSource() },
                    indication = null,
                    enabled = properties.dismissOnClickOutside,
                    onClick = {
                        onDismiss()
                    }
                ),
            contentAlignment = dialogAlignment
        ) {
            Card(
                modifier = Modifier
                    .widthIn(max = 400.dp)
                    .animateContentSize()
                    .padding(
                        top = WindowInsets.systemBars.asPaddingValues().calculateTopPadding(),
                        start = 24.dp,
                        end = 24.dp
                    )
                    .navigationBarsPadding()
                    .keyBoardPadding(keyBoardPadding)
                    .border(
                        width = customStyle?.borderWidth
                            ?: CommonDialogStyle.dialogStyle().borderWidth,
                        color = customStyle?.borderColor
                            ?: CommonDialogStyle.dialogStyle().borderColor,
                        shape = customStyle?.shape ?: CommonDialogStyle.dialogStyle().shape
                    )
                    .clickable(
                        interactionSource = remember { MutableInteractionSource() },
                        indication = null,
                        onClick = {}
                    ),

                shape = customStyle?.shape ?: CommonDialogStyle.dialogStyle().shape,
                colors = CardColors(
                    containerColor = customStyle?.background
                        ?: CommonDialogStyle.dialogStyle().background,
                    contentColor = Color.Unspecified,
                    disabledContainerColor = Color.Unspecified,
                    disabledContentColor = Color.Unspecified
                )
            ) {
                Column(
                    modifier = Modifier,
                ) {
                    title()
                    content()
                }
            }

        }
    }

}